module.exports = __webpack_public_path__ + "images/carouselImage1_530e96a.svg";